import { render, staticRenderFns } from "./ProductosComp.vue?vue&type=template&id=aad49d84&"
var script = {}
import style0 from "./ProductosComp.vue?vue&type=style&index=0&id=aad49d84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports